import React from 'react'
import styles from './ChatTabs.module.scss'

const ChatTabs = ({ dealData, activeDealId, onTabChange }) => {
  const mainClientId = dealData?.client?.id || dealData?.lead?.client?.id

  // Основная сделка (текущая)
  const mainDeal = {
    id: dealData?.id,
    client: dealData?.client || dealData?.lead?.client,
    session_id: dealData?.session_id,
    isMain: true,
  }

  // Объединенные сделки (исключая основного клиента)
  const combinedDeals =
    dealData?.combined_deals?.filter((combinedDeal) => {
      const combinedClient = combinedDeal.client || combinedDeal.lead?.client
      return combinedClient && combinedClient.id !== mainClientId
    }) || []

  const allDeals = [mainDeal, ...combinedDeals]

  if (allDeals.length <= 1) return null

  return (
    <div className={styles.tabsContainer}>
      <div className={styles.tabs}>
        {allDeals.map((deal) => {
          const mainClient = deal?.client || deal?.lead?.client

          return (
            <button
              key={deal.id}
              className={`${styles.tab} ${activeDealId === deal.id ? styles.active : ''}`}
              onClick={() => onTabChange(deal.id)}
            >
              <span className={styles.tabName}>
                {deal.isMain ? 'Основной чат' : `Чат сделки #${deal.id}`}
              </span>
              {mainClient && (
                <span className={styles.clientName}>
                  {mainClient.name || mainClient.phone || mainClient.email}
                </span>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default ChatTabs
